<template>
    <div class="form-text-objects-list-group">
        <label :for="id" class="form-text-objects-list-group__label" v-if="label">
            {{ label }}
            <span v-if="required" class="sah-input__label-flag">
                {{ requiredFieldLabelFlag }}
            </span>
        </label>
        <div :id="id">
            <form-text-object-group
                v-for="(element, index) in internalValue"
                :key="index"
                v-model="internalValue[index]"
                :label="multipleItems ? `${index + 1}` : ''"
            ></form-text-object-group>
            <div class="form-text-objects-list-group__append-element-container" v-if="multipleItems">
                <sah-button @press="appendElement" class="form-text-objects-list-group__append-element-button">
                    {{ $tc("applicationsFields.addItem") }}
                </sah-button>
            </div>
        </div>
    </div>
</template>
<script>
import FormTextObjectGroup from "./FormTextObjectGroup";
import {SahButton, mixins} from "atom";

const {Proxyable} = mixins;
export default {
    name: "form-text-objects-list-group",
    mixins: [Proxyable],
    props: {
        id: {
            type: String,
            default() {
                return `${this._uid}`;
            },
        },
        label: {type: String},
        required: {type: Boolean, default: false},
        requiredFieldLabelFlag: {type: String, default: "*"},
        value: {type: Array},
        multipleItems: {type: Boolean, default: false},
    },
    components: {
        FormTextObjectGroup,
        SahButton,
    },
    methods: {
        appendElement() {
            this.internalValue.push({en: ""});
        },
    },
    watch: {
        internalValue: {
            handler(value) {
                this.$emit("change", value);
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.form-text-objects-list-group::v-deep {
    @apply justify-center mb-2;

    .form-text-objects-list-group__label {
        @apply inline-block font-bold mb-1;
    }

    .form-text-objects-list-group__append-element-container {
        @apply mt-4 flex flex-col items-center;
    }

    .form-text-objects-list-group__append-element-button {
        @apply block rounded-full outline-none w-1/4;
        background-color: $text-filter-color;
        &:hover {
            @apply cursor-pointer;
            background-color: $text-filter-hover-color;
        }
    }
}
</style>
